function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M360.017 398.913l-137.515-84.921-137.51 84.9 54.296-135.345L0 180.667l171.07 1.27 51.426-136.122 51.43 136.13L445 180.699l-139.288 82.86 54.305 135.354"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M341.415 374.706l-118.794-73.358-118.789 73.342 46.904-116.92L30.41 186.176l147.781 1.096L222.617 69.68l44.427 117.598 147.784-1.078-120.325 71.58 46.912 116.926",
  fill: "#619cbc"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M162.291 183.74c.718 2.81 2.792 18.715 4.368 18.715 3.402 0 9.55-14.748 11.2-18.577 3.026 3.156 1.347 9.783 6.954 9.783 2.539 0 3.816-8.712 6.457-8.853.094 3.521.235 6.707-.97 10.775-1.858 6.272-6.56 14.77-11.18 14.77-3.31 0-7.921-6.35-8.827-6.35-.984 0-2.79.734-3.365 2.676-2.407 8.124 4.027 35.242 10.48 35.242 3.447 0 7.562-4.029 11.168-6.515-.94 9.771-1.07 18.01.173 26.418-3.287 3.318-7.136 4.716-10.226 4.716-15.854 0-7.11-58.744-21.73-71.259l5.498-11.54"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M223.227 179.033c11.982 0 16.713 34.341 11.337 52.486-4.171 14.076-11.567 24.28-21.04 24.28-16.732 0-14.635-36.336-8.108-58.366 1.8-6.069 7.95-19.297 12.76-19.297 1.768 0 3.232.897 5.05.897zm-.37 3.206c-1.887 0-3.546 1.485-4.42 4.442-1.837 6.196 7.321 12.467 6.006 16.902-.827 2.79-3.977 5.403-5.566 5.403-7.94 0-7.872-16.458-3.14-27.185-2.942 2.987-4.872 7.55-6.125 11.783-4.653 15.7-.96 37.299 9.658 37.299 5.868 0 12.626-8.399 15.251-17.264 3.232-10.9-5.032-31.38-11.665-31.38",
  fillRule: "evenodd"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M1784.998 1105.838c95.86 0 133.706-172.442 90.7-263.555-33.374-70.684-92.535-121.923-168.325-121.923-133.85 0-117.076 182.46-64.862 293.085 14.4 30.475 63.6 96.898 102.085 96.898 14.14 0 25.853-4.505 40.402-4.505z",
  fill: "none",
  stroke: "#000",
  strokeWidth: 159.009,
  strokeLinejoin: "round",
  strokeMiterlimit: 3.864,
  transform: "matrix(.125 0 0 -.19915 .102 399.256)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M1782.033 1089.742c-15.09 0-28.36-7.459-35.356-22.306-14.696-31.115 58.571-62.603 48.053-84.872-6.62-14.016-31.817-27.134-44.53-27.134-63.52 0-62.979 82.646-25.116 136.51-23.543-15-38.977-37.914-49.003-59.167-37.224-78.839-7.684-187.296 77.264-187.296 46.939 0 101.004 42.173 122.008 86.69 25.853 54.738-40.254 157.575-93.32 157.575z",
  fill: "none",
  stroke: "#000",
  strokeWidth: 159.009,
  strokeLinejoin: "round",
  strokeMiterlimit: 3.864,
  transform: "matrix(.125 0 0 -.19915 .102 399.256)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M277.684 235.569c-3.132 10.566-8.966 16.367-15.536 16.367-20.85 0-24.987-30.29-15.952-60.787 2.134-7.198 5.636-15.161 10.984-15.161 16.75 0 28.419 32.865 20.504 59.58zm-16.636-55.755c-1.538 0-2.887.886-3.625 3.376-1.622 5.476 7.203 10.359 7.215 16.017-.921 1.74-3.502 3.685-4.626 3.685-6.355 0-11.151-13.725-5.726-23.926-2.202 2.228-3.508 5.562-4.438 8.697-5.5 18.563 2.34 37.332 13.766 37.332 4.756 0 10.885-4.217 13.355-12.555 3.496-11.8-8.956-32.626-15.92-32.626",
  fillRule: "evenodd"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M162.291 183.74c.718 2.81 2.792 18.715 4.368 18.715 3.402 0 9.55-14.748 11.2-18.577 3.026 3.156 1.347 9.783 6.954 9.783 2.539 0 3.816-8.712 6.457-8.853.094 3.521.235 6.707-.97 10.775-1.858 6.272-6.56 14.77-11.18 14.77-3.31 0-7.921-6.35-8.827-6.35-.984 0-2.79.734-3.365 2.676-2.407 8.124 4.027 35.242 10.48 35.242 3.447 0 7.562-4.029 11.168-6.515-.94 9.771-1.07 18.01.173 26.418-3.287 3.318-7.136 4.716-10.226 4.716-15.854 0-7.11-58.744-21.73-71.259l5.498-11.54"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M1297.512 1082.2c5.74-14.105 22.336-93.976 34.943-93.976 27.218 0 76.408 74.06 89.603 93.287 24.205-15.85 10.777-49.126 55.633-49.126 20.307 0 30.521 43.745 51.654 44.455.749-17.68 1.88-33.681-7.758-54.106-14.866-31.494-52.477-74.168-89.448-74.168-26.483 0-63.365 31.882-70.61 31.882-7.872 0-22.316-3.682-26.925-13.434-19.25-40.791 32.218-176.966 83.838-176.966 27.583 0 60.498 20.233 89.347 32.718-7.512-49.069-8.555-90.442 1.383-132.66-26.29-16.659-57.087-23.681-81.801-23.681-126.838 0-56.888 294.98-173.845 357.825z",
  fill: "none",
  stroke: "#000",
  strokeWidth: 13.251,
  strokeMiterlimit: 3.864,
  transform: "matrix(.125 0 0 -.19915 .102 399.256)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M223.227 179.033c11.982 0 16.713 34.341 11.337 52.486-4.171 14.076-11.567 24.28-21.04 24.28-16.732 0-14.635-36.336-8.108-58.366 1.8-6.069 7.95-19.297 12.76-19.297 1.768 0 3.232.897 5.05.897zm-.37 3.206c-1.887 0-3.546 1.485-4.42 4.442-1.837 6.196 7.321 12.467 6.006 16.902-.827 2.79-3.977 5.403-5.566 5.403-7.94 0-7.872-16.458-3.14-27.185-2.942 2.987-4.872 7.55-6.125 11.783-4.653 15.7-.96 37.299 9.658 37.299 5.868 0 12.626-8.399 15.251-17.264 3.232-10.9-5.032-31.38-11.665-31.38",
  fillRule: "evenodd"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M1784.998 1105.838c95.86 0 133.706-172.442 90.7-263.555-33.374-70.684-92.535-121.923-168.325-121.923-133.85 0-117.076 182.46-64.862 293.085 14.4 30.475 63.6 96.898 102.085 96.898 14.14 0 25.853-4.505 40.402-4.505z",
  fill: "none",
  stroke: "#000",
  strokeWidth: 13.251,
  strokeMiterlimit: 3.864,
  transform: "matrix(.125 0 0 -.19915 .102 399.256)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M1782.033 1089.742c-15.09 0-28.36-7.459-35.356-22.306-14.696-31.115 58.571-62.603 48.053-84.872-6.62-14.016-31.817-27.134-44.53-27.134-63.52 0-62.979 82.646-25.116 136.51-23.543-15-38.977-37.914-49.003-59.167-37.224-78.839-7.684-187.296 77.264-187.296 46.939 0 101.004 42.173 122.008 86.69 25.853 54.738-40.254 157.575-93.32 157.575z",
  fill: "none",
  stroke: "#000",
  strokeWidth: 13.251,
  strokeMiterlimit: 3.864,
  transform: "matrix(.125 0 0 -.19915 .102 399.256)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M277.684 235.569c-3.132 10.566-8.966 16.367-15.536 16.367-20.85 0-24.987-30.29-15.952-60.787 2.134-7.198 5.636-15.161 10.984-15.161 16.75 0 28.419 32.865 20.504 59.58zm-16.636-55.755c-1.538 0-2.887.886-3.625 3.376-1.622 5.476 7.203 10.359 7.215 16.017-.921 1.74-3.502 3.685-4.626 3.685-6.355 0-11.151-13.725-5.726-23.926-2.202 2.228-3.508 5.562-4.438 8.697-5.5 18.563 2.34 37.332 13.766 37.332 4.756 0 10.885-4.217 13.355-12.555 3.496-11.8-8.956-32.626-15.92-32.626",
  fillRule: "evenodd"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M2220.652 821.948c-25.05-53.06-71.727-82.19-124.286-82.19-166.8 0-199.895 152.098-127.61 305.239 17.071 36.145 45.087 76.133 87.864 76.133 134 0 227.354-165.029 164.032-299.182z",
  fill: "none",
  stroke: "#000",
  strokeWidth: 13.251,
  strokeMiterlimit: 3.864,
  transform: "matrix(.125 0 0 -.19915 .102 399.256)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M2087.568 1101.916c-12.304 0-23.1-4.449-28.998-16.951-12.976-27.498 57.62-52.015 57.719-80.43-7.373-8.732-28.016-18.504-37.01-18.504-50.839 0-89.209 68.922-45.809 120.143-17.612-11.185-28.065-27.927-35.503-43.668-44.006-93.217 18.726-187.461 110.13-187.461 38.042 0 87.078 21.172 106.837 63.041 27.966 59.257-71.645 163.83-127.366 163.83z",
  fill: "none",
  stroke: "#000",
  strokeWidth: 13.251,
  strokeMiterlimit: 3.864,
  transform: "matrix(.125 0 0 -.19915 .102 399.256)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M162.291 183.74c.718 2.81 2.792 18.715 4.368 18.715 3.402 0 9.55-14.748 11.2-18.577 3.026 3.156 1.347 9.783 6.954 9.783 2.539 0 3.816-8.712 6.457-8.853.094 3.521.235 6.707-.97 10.775-1.858 6.272-6.56 14.77-11.18 14.77-3.31 0-7.921-6.35-8.827-6.35-.984 0-2.79.734-3.365 2.676-2.407 8.124 4.027 35.242 10.48 35.242 3.447 0 7.562-4.029 11.168-6.515-.94 9.771-1.07 18.01.173 26.418-3.287 3.318-7.136 4.716-10.226 4.716-15.854 0-7.11-58.744-21.73-71.259l5.498-11.54"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M223.227 179.033c11.982 0 16.713 34.341 11.337 52.486-4.171 14.076-11.567 24.28-21.04 24.28-16.732 0-14.635-36.336-8.108-58.366 1.8-6.069 7.95-19.297 12.76-19.297 1.768 0 3.232.897 5.05.897zm-.37 3.206c-1.887 0-3.546 1.485-4.42 4.442-1.837 6.196 7.321 12.467 6.006 16.902-.827 2.79-3.977 5.403-5.566 5.403-7.94 0-7.872-16.458-3.14-27.185-2.942 2.987-4.872 7.55-6.125 11.783-4.653 15.7-.96 37.299 9.658 37.299 5.868 0 12.626-8.399 15.251-17.264 3.232-10.9-5.032-31.38-11.665-31.38",
  fillRule: "evenodd"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M1784.998 1105.838c95.86 0 133.706-172.442 90.7-263.555-33.374-70.684-92.535-121.923-168.325-121.923-133.85 0-117.076 182.46-64.862 293.085 14.4 30.475 63.6 96.898 102.085 96.898 14.14 0 25.853-4.505 40.402-4.505z",
  fill: "none",
  stroke: "#000",
  strokeWidth: 159.009,
  strokeLinejoin: "round",
  strokeMiterlimit: 3.864,
  transform: "matrix(.125 0 0 -.19915 .102 399.256)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M1782.033 1089.742c-15.09 0-28.36-7.459-35.356-22.306-14.696-31.115 58.571-62.603 48.053-84.872-6.62-14.016-31.817-27.134-44.53-27.134-63.52 0-62.979 82.646-25.116 136.51-23.543-15-38.977-37.914-49.003-59.167-37.224-78.839-7.684-187.296 77.264-187.296 46.939 0 101.004 42.173 122.008 86.69 25.853 54.738-40.254 157.575-93.32 157.575z",
  fill: "none",
  stroke: "#000",
  strokeWidth: 159.009,
  strokeLinejoin: "round",
  strokeMiterlimit: 3.864,
  transform: "matrix(.125 0 0 -.19915 .102 399.256)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M277.684 235.569c-3.132 10.566-8.966 16.367-15.536 16.367-20.85 0-24.987-30.29-15.952-60.787 2.134-7.198 5.636-15.161 10.984-15.161 16.75 0 28.419 32.865 20.504 59.58zm-16.636-55.755c-1.538 0-2.887.886-3.625 3.376-1.622 5.476 7.203 10.359 7.215 16.017-.921 1.74-3.502 3.685-4.626 3.685-6.355 0-11.151-13.725-5.726-23.926-2.202 2.228-3.508 5.562-4.438 8.697-5.5 18.563 2.34 37.332 13.766 37.332 4.756 0 10.885-4.217 13.355-12.555 3.496-11.8-8.956-32.626-15.92-32.626",
  fillRule: "evenodd"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M162.291 183.74c.718 2.81 2.792 18.715 4.368 18.715 3.402 0 9.55-14.748 11.2-18.577 3.026 3.156 1.347 9.783 6.954 9.783 2.539 0 3.816-8.712 6.457-8.853.094 3.521.235 6.707-.97 10.775-1.858 6.272-6.56 14.77-11.18 14.77-3.31 0-7.921-6.35-8.827-6.35-.984 0-2.79.734-3.365 2.676-2.407 8.124 4.027 35.242 10.48 35.242 3.447 0 7.562-4.029 11.168-6.515-.94 9.771-1.07 18.01.173 26.418-3.287 3.318-7.136 4.716-10.226 4.716-15.854 0-7.11-58.744-21.73-71.259l5.498-11.54",
  fill: "#fff"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M223.227 179.033c11.982 0 16.713 34.341 11.337 52.486-4.171 14.076-11.567 24.28-21.04 24.28-16.732 0-14.635-36.336-8.108-58.366 1.8-6.069 7.95-19.297 12.76-19.297 1.768 0 3.232.897 5.05.897zm-.37 3.206c-1.887 0-3.546 1.485-4.42 4.442-1.837 6.196 7.321 12.467 6.006 16.902-.827 2.79-3.977 5.403-5.566 5.403-7.94 0-7.872-16.458-3.14-27.185-2.942 2.987-4.872 7.55-6.125 11.783-4.653 15.7-.96 37.299 9.658 37.299 5.868 0 12.626-8.399 15.251-17.264 3.232-10.9-5.032-31.38-11.665-31.38m54.828 53.33c-3.132 10.566-8.966 16.367-15.536 16.367-20.85 0-24.987-30.29-15.952-60.787 2.134-7.198 5.636-15.161 10.984-15.161 16.75 0 28.419 32.865 20.504 59.58zm-16.636-55.755c-1.538 0-2.887.886-3.625 3.376-1.622 5.476 7.203 10.359 7.215 16.017-.921 1.74-3.502 3.685-4.626 3.685-6.355 0-11.151-13.725-5.726-23.926-2.202 2.228-3.508 5.562-4.438 8.697-5.5 18.563 2.34 37.332 13.766 37.332 4.756 0 10.885-4.217 13.355-12.555 3.496-11.8-8.956-32.626-15.92-32.626",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M359.8 399.256l-137.415-85.021-137.409 84.999 54.256-135.503L.045 180.754l170.946 1.272L222.38 45.744l51.392 136.29 170.95-1.248-139.187 82.958L359.8 399.256"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M341.415 374.706l-118.794-73.358-118.789 73.342 46.904-116.92L30.41 186.176l147.781 1.096L222.617 69.68l44.427 117.598 147.784-1.078-120.325 71.58 46.912 116.926",
  fill: "#619cbc"
});

function SvgGroovy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 445 445"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
}

export default __webpack_public_path__ + "static/groovy.87c1b4b3.svg";
export { SvgGroovy as ReactComponent };